import { useApi } from '../composables'
import http from '../composables/src/useHttp'

export const getAllTicketTypes = () => {
  return useApi(http.get(`/settings/ticket-types`))
}
export const deleteTicketType = (id: string) => {
  return useApi(http.delete(`/settings/ticket-types/${id}`))
}
export const createTicketType = (data: any) => {
  return useApi(http.post(`/settings/ticket-types`, data))
}
export const updateTicketType = (id: string, data: any) => {
  return useApi(http.put(`/settings/ticket-types/${id}`, data))
}
export const updateTicketTypePositions = (positions: { id: string; position: number }[]) => {
  return useApi(http.patch(`/settings/ticket-types/positions`, { positions }))
}
